import { ConstantsEnum } from "@ch/helpers/utils/enums.ts";
import { useEffect } from "react";
import { enableAnalytics } from "@ch/api";

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

function useSendMsClaritySignal(sendClaritySignal: boolean) {
  const grantClarityConsent = () => {
    if (
      typeof window !== "undefined" &&
      typeof window?.clarity === "function"
    ) {
      window?.clarity("consentv2", {
        ad_Storage: "granted",
        analytics_Storage: "granted",
      });
      localStorage.setItem(ConstantsEnum.CLARITY_ACCEPT_COOKIES, "true");
    }
  };

  useEffect(() => {
    function withClarity() {
      const isCookiesAccepted =
        localStorage.getItem(ConstantsEnum.ACCEPT_COOKIES) === "true";
      const isClarityConsentSent =
        localStorage.getItem(ConstantsEnum.CLARITY_ACCEPT_COOKIES) === "true";

      if (sendClaritySignal || (isCookiesAccepted && !isClarityConsentSent)) {
        grantClarityConsent();
      }
    }

    if (enableAnalytics) withClarity();
  }, [sendClaritySignal]);

  return null;
}

export default useSendMsClaritySignal;
